import { Location } from "@/reports/config/locations";
import { CustomColumns } from "@/types/Table";
import { UserInfo } from "@/user-control/types/UserInfo";
import { displayLocationName } from "@/utils/display";
import { Button } from "antd";

export const getStaffTableColumns = (
  viewDetailsClick: (userId: number) => void
): CustomColumns<UserInfo> => {
  const columns: CustomColumns<UserInfo> = [
    {
      title: "Full Name",
      dataIndex: "Name",
      sorter: (a, b) => a.Name.localeCompare(b.Name),
      defaultSortOrder: "ascend",
    },
    {
      title: "Role",
      dataIndex: "Role",
    },
    {
      title: "Current Location",
      dataIndex: "Location",
      render: (value: Location) => displayLocationName(value),
    },
    {
      title: "",
      key: "actions",
      render: (row) => (
        <div>
          <Button type="link" onClick={() => viewDetailsClick(row.UserId)}>
            View Details
          </Button>
        </div>
      ),
    },
  ];
  return columns;
};
